import CoachChatEmbedded, {
  type Props as CoachChatEmbeddedProps,
} from 'bundles/ai-course-coach/components/CoachChatEmbedded';
import { ExternalCoachLauncher } from 'bundles/ai-course-coach/components/Launcher';
import { CoachPermissionsWrapper } from 'bundles/ai-course-coach/utils/CoachPermissionWrapper';

// component exports
export { CoachChatEmbedded, CoachPermissionsWrapper, ExternalCoachLauncher };

export type { CoachChatEmbeddedProps };
